import { render, staticRenderFns } from "./vue-my-dropdown.vue?vue&type=template&id=c90ca652"
import script from "./vue-my-dropdown.vue?vue&type=script&lang=js"
export * from "./vue-my-dropdown.vue?vue&type=script&lang=js"
import style0 from "./vue-my-dropdown.vue?vue&type=style&index=0&id=c90ca652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports